import React from "react";
import TodayCircle from "./TodayCircle";

export default class Day extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      date,
      handleDayClick,
      handleDayDoubleClick,
      isToday,
      isRed,
      isOverflow,
      graphicCNs,
      isSelected,
      isActive,
      isHighlighted,
      selectedCircle,
    } = this.props;
    let className = "Day";
    if (isRed) {
      className += " red";
    }
    if (isSelected) {
      className += " selected";
    }
    if (isHighlighted) {
      className += " highlighted";
    }
    if (isActive) {
      className += " active";
    }
    isOverflow && (className += " overflow-day");
    const dayNumber = date.getDate();

    if (isToday) {
      return (
        <button
          className={className + " today"}
          style={{ gridColumnStart: date.getDay() + 1 }}
          data-cy={"day-button-" + (date.getMonth() + 1) + "-" + date.getDate()}
          onClick={handleDayClick}
        >
          {(isSelected || isActive) && selectedCircle}
          <TodayCircle dayNumber={dayNumber} />
          {graphicCNs}
          {isHighlighted && <div className="highlight start"></div>}
        </button>
      );
    } else {
      return (
        <button
          className={className}
          onClick={handleDayClick}
          onDoubleClick={handleDayDoubleClick}
          data-cy={"day-button-" + (date.getMonth() + 1) + "-" + date.getDate()}
        >
          {(isSelected || isActive) && selectedCircle}
          {dayNumber}
          {graphicCNs}
          {isHighlighted && (
            <div
              className={
                "highlight" +
                (isSelected ? " end" : "") +
                (isActive ? " start" : "")
              }
            ></div>
          )}
        </button>
      );
    }
  }
}
